import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { TransactionFilterKey } from 'api/Transaction/Types/Transaction'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { CompaniesFilter, CustomDateFilter } from './common.filter'
import { TransactionStatusFilter } from './TransactionFields/TransactionStatusFilter'

export const getIBTransactionsFilters = (): FieldSettings[] => [
  {
    name: TransactionFilterKey.reference,
    label: 'Reference',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TransactionFilterKey.state,
    label: 'Status',
    filter: TransactionStatusFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TransactionFilterKey.walletTransactionWalletCompany,
    label: 'Company',
    filter: CompaniesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  // TODO: temporary is hidden (backend in progress)
  // {
  //     name: TransactionFilterKey.ibNumber,
  //     label: 'IB number',
  //     filter: TextFilter,
  //     operators: [
  //          { text: GridFilterOperatorNameEnum.equalOperator, operator: GridFilterOperatorEnum.equalOperator },
  //          { text: GridFilterOperatorNameEnum.notEqOperator, operator: GridFilterOperatorEnum.notEqOperator },
  //     ],
  // },
  {
    name: TransactionFilterKey.createdDate,
    label: 'Date Created',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
  {
    name: TransactionFilterKey.updatedDate,
    label: 'Date Updated',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
]
